import React, { useEffect, useRef, useState } from "react";

import { Col, Row, Table } from "antd";
import { HeaderComponent } from "../../components/base";
import AuthenticatedRoute from "../../core/routes/AuthenticatedRoute";
import { Paths } from "../../config/paths";

import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ClientDataProps, FormTypeEnum, ReduxType } from "../../shared/types";
import { API_URL } from "../../config/general-config";
import { Endpoints } from "../../config/endpoints";
import { getClientByIdAction, getClientsAction } from "../../store/clients/actions";
import { Pagination } from "antd";
import { SimpleSearchForm } from "../../components/forms";
import { TableRowSelection } from "antd/lib/table/interface";

const ClientPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentSearchValue, setCurrentSearchValue] = useState<
    string | undefined
  >();
  const [paginationHeight, setPaginationHeight] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const paginationRef = useRef<any>(null);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const { state }: any = useLocation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { clientData } = useSelector((state: ReduxType) => {
    return state;
  });

  useEffect(() => {
    if (paginationRef && paginationRef.current)
      setPaginationHeight(paginationRef.current.clientHeight);
  }, [paginationRef]);

  useEffect(() => {
    if (currentPage) {
      doRequest(currentPage, currentSearchValue);
    }
  }, [currentPage]);

  useEffect(() => {
    if (currentSearchValue) {
      doRequest(1, currentSearchValue);
    }
  }, [currentSearchValue]);

  const doRequest = async (page: number, searchValue: string | undefined) => {
    let url = `${API_URL}/${Endpoints.CLIENTS_WITH_PARAMETERS}`;
    if (page) {
      url += `?page=${page}&pageSize=10`;
    }
    if (searchValue) {
      url += `&razonsocial=${searchValue}`;
    }
    await dispatch(getClientsAction(url));
  };

  const rowSelection: TableRowSelection<any> = {
    onSelect: async (record) => {
      setSelectedRowKeys([record.key]);
      await dispatch(getClientByIdAction(record._id));
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
    selectedRowKeys: selectedRowKeys,
  };

  const columns = [
    {
      title: "Código",
      dataIndex: "codigo",
      render(text: any, record: any) {
        return {
          props: {
            style: { color: "#706F6E" },
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: "Razón social",
      dataIndex: "razonsocial",
      render(text: any, record: any) {
        return {
          props: {
            style: { color: "#706F6E" },
          },
          children: <div>{text}</div>,
        };
      },
    },
  ];

  const dataSourceTable: any[] | undefined =
    clientData.clients &&
    clientData.clients.data &&
    clientData.clients.data.map((col: ClientDataProps, index: number) => {
      return { key: index, ...col };
    });

  return (
    <AuthenticatedRoute
      path={Paths.CLIENTS}
      withHeader
      headerNavigationName={
        state && state.formType == FormTypeEnum.Quote
          ? "Nueva Cotización"
          : "Nuevo Pedido"
      }
      goBack={() =>
        navigate(state && state.from, {
          state: {
            formType: state && state.formType,
            editMode: state && state.editMode,
            canEdit: state && state.canEdit,
            ref: state && state.ref,
          },
        })
      }
    >
      {!isLoading && (
        <>
          <SimpleSearchForm
            inputName={"clientSearch"}
            placeholder={"Razón social"}
            onSearch={(value) => setCurrentSearchValue(value)}
          />
          <Row
            align="middle"
            justify="space-between"
            style={{ marginBottom: paginationHeight }}
          >
            <Col span={24}>
              <Table
                id={"custom-table"}
                rowSelection={{
                  type: "radio",
                  ...rowSelection,
                }}
                rowClassName="row-selection"
                onRow={(record) => ({
                  onClick: async () => {
                    setSelectedRowKeys([record.key]);
                      await dispatch(getClientByIdAction(record._id));
                  },
                })}
                columns={columns}
                dataSource={dataSourceTable}
                pagination={false}
              />
            </Col>
          </Row>

          {clientData.clients && clientData.clients && (
            <div
              style={{
                padding: 10,
                backgroundColor: "#f0f0f0",
                position: "fixed",
                bottom: 0,
                width: "100%",
              }}
              ref={paginationRef}
            >
              <Pagination
                style={{ float: "right" }}
                current={currentPage}
                onChange={(page) => setCurrentPage(page)}
                total={clientData.clients.total}
                showSizeChanger={false}
              />
            </div>
          )}
        </>
      )}
    </AuthenticatedRoute>
  );
};

export default ClientPage;
